import React from 'react';
import { SOPModel } from 'src/models/services/sop';
import { API_url } from '../api.setup';
import axios from 'axios';
import { enqueueSnackbar } from 'notistack';

const API_Controller = '/SOP';

export const SOPServices = {
  getAllData: async () => {
    try {
      const response = await axios.get(`${API_url}${API_Controller}/getall`);
      return response.data as SOPModel[];
    } catch (error) {
      throw error;
    }
  },

  addData: async (dataToAdd: SOPModel) => {
    const reModel = {
      Name: dataToAdd.name,
      Description: dataToAdd.description,
      Images: 'some url',
      Videos: 'some video url',
      Status: dataToAdd.status
    };
    try {
      const response = await axios.post(`${API_url}${API_Controller}`, reModel);
      enqueueSnackbar(`SOP Added Successfully`, {
        variant: 'success'
      });
      return response.data as SOPModel[];
    } catch (error) {
      enqueueSnackbar(`SOP Add unsuccessfully`, {
        variant: 'success'
      });
      throw error;
    }
  },

  editData: async (dataToUpdate: SOPModel) => {
    const reModel = {
      Id: dataToUpdate.id,
      Name: dataToUpdate.name,
      Description: dataToUpdate.description,
      Images: 'some url',
      Videos: 'some video url',
      Status: dataToUpdate.status
    };
    try {
      const respons = await axios.put(
        `${API_url}${API_Controller}/update`,
        reModel
      );
      enqueueSnackbar(`SOP edited Successfully`, {
        variant: 'success'
      });

      return respons.data as SOPModel[];
    } catch (error) {
      enqueueSnackbar(`SOP edit unsuccessful`, {
        variant: 'error'
      });
      throw error;
    }
  },

  deleteData: async (deleteId, data) => {
    try {
      const response = await axios.delete(
        `${API_url}${API_Controller}/delete?id=${deleteId}`
      );
      enqueueSnackbar(`SOP deleted Successfully`, {
        variant: 'success'
      });
      return response.data as SOPModel[];
    } catch (error) {
      enqueueSnackbar(`SOP  delete unsuccessful. Assinged to service`, {
        variant: 'error'
      });
      throw error;
    }
  }
};
